import { Link } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import { useDashboardRecentInvoices } from '../../api/dashboard.js';
import { EmptyState } from '../../components/EmptyState.js';
import { formatAmount, formatRelative } from '../invoices/format.js';

// REQ-FE-029c-2 — Wires to `GET /api/dashboard/recent-invoices` (REQ-BE-029-be B).
// Returns the N most-recent invoices across every tenant the caller
// has read access on. The mockup shows 5 rows; default limit 5.
export function RecentInvoicesTable() {
  const q = useDashboardRecentInvoices(5);
  const rows = q.data ?? [];

  return (
    <section
      className="recent-invoices"
      data-testid="dashboard-recent-invoices"
      aria-label="Dernières factures reçues à travers le groupe"
    >
      <div className="eyebrow">5 dernières factures reçues · groupe</div>
      {q.isLoading ? (
        <p className="muted" data-testid="dashboard-recent-invoices-loading">
          Chargement…
        </p>
      ) : q.isError ? (
        <EmptyState
          testId="dashboard-recent-invoices-error"
          variant="inline"
          icon="⚠️"
          title="Impossible de charger"
          description="Les dernières factures reçues n'ont pas pu être chargées."
        />
      ) : rows.length === 0 ? (
        <EmptyState
          testId="dashboard-recent-invoices-empty"
          variant="inline"
          icon={<Inbox aria-hidden="true" size={18} strokeWidth={1.5} />}
          title="Aucune facture récente"
          description="Aucune facture reçue récemment à travers les sociétés du groupe."
        />
      ) : (
        <ul className="recent-invoices__list" data-testid="dashboard-recent-invoices-list">
          {rows.map((r) => (
            <li
              key={r.primaryKey}
              className="recent-invoices__row"
              data-testid={`dashboard-recent-invoice-${r.primaryKey}`}
            >
              <Link
                to={`/t/${r.tenantId}/invoices/${encodeURIComponent(r.primaryKey)}`}
                className="recent-invoices__link"
              >
                <span className="recent-invoices__supplier">{r.supplier?.name ?? '—'}</span>
                <span className="recent-invoices__amount">
                  {formatAmount(r.totalAmount, 'EUR')}
                </span>
                <span className="recent-invoices__tenant muted">
                  {r.tenantName ?? r.tenantId.slice(0, 8)}
                </span>
                <span className="recent-invoices__received muted">
                  {formatRelative(r.receivedAt)}
                </span>
                <span className="recent-invoices__state muted">{r.state}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
